import { render, staticRenderFns } from "./columnList.vue?vue&type=template&id=70f5239e&scoped=true&"
import script from "./columnList.vue?vue&type=script&lang=js&"
export * from "./columnList.vue?vue&type=script&lang=js&"
import style0 from "./columnList.vue?vue&type=style&index=0&id=70f5239e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f5239e",
  null
  
)

export default component.exports